<template>
  <main class="l-main p-register">
    <div class="l-block">
      <TitleRegister></TitleRegister>
      <div v-if="status === 'pending'" class="l-block__content provisional">
        <div class="message">
          <h1>メールアドレス確認が完了していません</h1>
          <div class="c-text--center">
            <img
              :src="require('@/assets/img/img-register-provisional.gif')"
              alt="仮会員登録となります"
            />
          </div>
          <p>
            確認メール内のURLにアクセスし、メールアドレス確認を完了させてください。<br />メールが届いていない場合は、カスタマーサポート(<a
              :href="'mailto:' + $constants.customerSupportEmail"
              >{{ $constants.customerSupportEmail }}</a
            >)までご連絡いただきますようお願いいたします。
          </p>
        </div>
      </div>
      <div v-else class="l-block__content error">
        <div class="message">
          <h1>
            {{
              status === 'expired'
                ? 'アクセス有効期限が切れました'
                : 'エラーが発生しました'
            }}
          </h1>
          <div class="c-text--center">
            <p>
              担当営業から案内されたユーザー登録URLがわかる場合は再度、会員登録をお願いします。<br />
              ユーザー登録のURLがご不明な場合は、再度、担当営業にご連絡をお願いします。
            </p>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import TitleRegister from '@/components/TitleRegister';

export default {
  components: {
    TitleRegister
  },

  data() {
    return {
      status: 'error'
    };
  },

  computed: {
    emailVerified() {
      return this.$store.state.user.status.emailVerified;
    },
    queryMessage() {
      return this.$route.query.message;
    }
  },

  created() {
    if (this.queryMessage) {
      if (this.queryMessage.indexOf('This URL can be used only once') !== -1) {
        this.status = 'expired';
      } else if (this.queryMessage.indexOf('Access expired') !== -1) {
        this.status = 'expired';
      } else if (
        this.queryMessage.indexOf('This account is already verified') !== -1
      ) {
        this.status = 'verified';
      }
    } else if (this.auth.isAuthenticated && !this.emailVerified) {
      this.status = 'pending';
    }

    // 認証済みなのに認証URLを叩いてこのページに来た場合は、登録完了ページに遷移
    if (this.status === 'verified') {
      this.$router.replace({ name: 'registerRegister' });
    }
  }
};
</script>
